import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout.jsx';
import { AboutPage } from './pages/AboutPage.jsx';
import { CastPage } from './pages/CastPage.jsx';
import { HomePage } from './pages/HomePage.jsx';
import { MediaPage } from './pages/MediaPage.jsx';

export default function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/cast" element={<CastPage />} />
        <Route path="/media" element={<MediaPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}
